export let version:string = '2.12.0';


// WEBPACK FOOTER //
// ./src/version.ts